import React from 'react';
import background from '../../assets/rfsa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoRfsa extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Moscow, Russia"
        description="RFSA"
        paragraph="The Russian Federal Space Agency, known as Roscosmos, is a state corporation of the Russian Federation responsible for space flights, cosmonautics programs, and aerospace research."
        background={background}
     />
  
  );
 }
}   

export default InfoRfsa;